import {react2panel} from 'common/util/react2panel';

import {SpinnerReact} from './index';

// Lazy initialization to avoid circular dependency with `panel` at module load time
let cachedSpinnerEl: ((props: any) => any) | null = null;
export const SpinnerEl = ((props: any) => {
  if (!cachedSpinnerEl) {
    cachedSpinnerEl = react2panel(`mp-spinner`, SpinnerReact);
  }
  return cachedSpinnerEl(props);
}) as ReturnType<typeof react2panel>;
